import { apiSlice } from '../api/apiSlice';
import {
  FaqParams,
  FaqResponse,
  FaqsParams,
  FaqsResponse,
} from './faqApiSliceTypes';

const esimApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getFaqs: builder.query<FaqsResponse, FaqsParams>({
      query: (params) => ({
        url: '/faq',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
      }),
    }),

    getFaq: builder.query<FaqResponse, FaqParams>({
      query: (params) => {
        return {
          url: `/faq/${params.id}`,
          method: 'GET',
          headers: {
            'Accept-Language': params.acceptLanguage ?? 'en',
          },
        };
      },
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetFaqQuery,
  useGetFaqsQuery,
  useLazyGetFaqQuery,
  useLazyGetFaqsQuery,
} = esimApiSlice;
